/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setCardisleGridViewSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getCardisleGridViewSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';

const CardisleGridViewABTest = ({ pageType }) => {
    const dispatchAction = useDispatch();
    const cardisleGridViewSaleForceABTestData = useSelector(getCardisleGridViewSaleForceABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Cardisle-Checkout-AddOn-GridView-AB',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    useClickStreamCustomEventsTracking({
        salesforceResponse: data?.contentSF,
        isFireImpression: !!data?.contentSF,
        page: { type: pageType },
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'CardisleGridViewABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Cardisle Grid View Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== cardisleGridViewSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatchAction(setCardisleGridViewSaleForceABTest(data.contentSF));
    }

    return null;
};

CardisleGridViewABTest.propTypes = {
    pageType: string.isRequired,
};

export default CardisleGridViewABTest;
